import React from 'react';
import PropTypes from 'prop-types';
import { FormattedTime } from 'react-intl';

import FormattedPrice from '../../misc/FormattedPrice';
import { FormattedMessageWrappedInSpan } from '../../misc';
import { PrimaryButton, SecondaryButton } from '../../misc/Buttons';
import { trackEvent } from '../../../utils/ga-tracking';

const ThumbnailPreviewEventDetails = props => {
  const {
    photoSgId,
    shotDate,
    showTagButton,
    fotoFlatProduct,
    singlePhotoProduct,
    onBuySinglePhoto,
    onBuyFotoFlat,
    onShowRecheckView,
    eventHasSearchByFace,
    showRecheckNotification,
  } = props;

  if (showRecheckNotification) {
    
    return (
      <div className="thumbnail-preview-recheck-notification">
        <h1>
          <FormattedMessageWrappedInSpan
            id="thumbnailPreviewEventDetails.recheckSuccessNotification.title"
            defaultMessage="Thank You!"
          />
        </h1>
        {eventHasSearchByFace && 
          <FormattedMessageWrappedInSpan
            id="thumbnailPreviewEventDetails.searchByFaceRecheckSuccessNotification.description"
            defaultMessage="You've tagged the photo. After we check your tag, we will send you an email-notification. Please be patient."
          />
        }
        {!eventHasSearchByFace && 
          <FormattedMessageWrappedInSpan
            id="thumbnailPreviewEventDetails.recheckSuccessNotification.description"
            defaultMessage="You've tagged the photo with your start number. After we check your tag, we will send you an email-notification. Please be patient."
          />
        }
      </div>
    );
  }

  return (
    <div className="thumbnail-preview-details">
      <div className="row">
        <div className="col-xs-16 col-sm-6">
          <div className="thumbnail-preview-photo-number">
            <span>{photoSgId}</span>
          </div>
          {shotDate && (
            <div className="thumbnail-preview-time">
              <FormattedTime
                value={new Date(shotDate)}
                timeZone="UTC"
                hour="2-digit"
                minute="2-digit"
                second="2-digit"
              />
            </div>
          )}
        </div>
        <div className="col-xs-16 col-sm-7 col-sm-offset-3">
          <div className="thumbnail-preview-details-actions">
            {fotoFlatProduct && (
              <PrimaryButton
                hasFullWidth={true}
                leftLabel={
                  <FormattedMessageWrappedInSpan
                    id="thumbnailPreviewEventDetails.actions.buyFotoFlatButton"
                    defaultMessage="Buy Foto-Flat"
                  />
                }
                rightLabel={<FormattedPrice price={fotoFlatProduct.price} />}
                onClick={() => {
                  trackEvent('Event', 'Buy', 'Foto-Flat button');
                  onBuyFotoFlat();
                }}
              />
            )}
            {!fotoFlatProduct && showTagButton && (
              <PrimaryButton
                hasFullWidth={true}
                leftLabel={
                  <FormattedMessageWrappedInSpan
                    id="thumbnailPreviewEventDetails.actions.addToFotoFlat"
                    defaultMessage="That's me"
                  />
                }
                onClick={onShowRecheckView}
              />
            )}
            {Boolean(singlePhotoProduct) && (
              <SecondaryButton
                hasFullWidth={true}
                leftLabel={
                  <FormattedMessageWrappedInSpan
                    id="thumbnailPreviewEventDetails.actions.buySinglePhoto"
                    defaultMessage="Buy single photo"
                  />
                }
                rightLabel={<FormattedPrice price={singlePhotoProduct.price} />}
                onClick={() => {
                  trackEvent('Event', 'Buy', 'Single photo button');
                  onBuySinglePhoto();
                }}
              />
            )}
            {Boolean(fotoFlatProduct) && showTagButton && (
              <SecondaryButton
                hasFullWidth={true}
                leftLabel={
                  <FormattedMessageWrappedInSpan
                    id="thumbnailPreviewEventDetails.actions.addToFotoFlat"
                    defaultMessage="That's me"
                  />
                }
                onClick={onShowRecheckView}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

ThumbnailPreviewEventDetails.propTypes = {
  showTagButton: PropTypes.bool,
  photoSgId: PropTypes.number,
  shotDate: PropTypes.string,
  eventHasSearchByFace: PropTypes.bool,
  showRecheckNotification: PropTypes.bool,
  fotoFlatProduct: PropTypes.object,
  singlePhotoProduct: PropTypes.object,
  onBuyFotoFlat: PropTypes.func,
  onBuySinglePhoto: PropTypes.func,
  onShowRecheckView: PropTypes.func,
};

export default ThumbnailPreviewEventDetails;
